import { ReplaySubject ,  Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable ({
  providedIn: 'root'
})
export class CommonDataSharedService {

  studentProfile: any;
  careerTabSelect = new Subject();
  studentCareerSelect = new Subject();
  careerTabSubmit = new Subject();
  countUpdate = new Subject();
  planProgressData = new Subject();
  parentHomeData = new Subject();
  studentQuestionaryThreeActivityData = new Subject();
  studentQuestionaryThreeOtherActivityData = new Subject();
  studentQuestionaryThreeMusicData = new Subject();
  studentQuestionaryThreeROTCData = new Subject();
  studentQuestionaryThreeSportsFirstData = new Subject();
  studentQuestionaryThreeSportsSecondData = new Subject();
  studentQuestionaryThreeSportsThirdData = new Subject();
  studentQuestionaryThreeSeeMySelfData = new Subject();
  studentQuestionaryThreelyfAboutYouData = new Subject();
  studentQuestionaryThreeOtherActivityTextData = new Subject();
  studentQuestionaryThreeActivityTextData = new Subject();
  studentQuestionaryThreeMusicTextData = new Subject();
  studentQuestionaryThreeSportsTextData = new Subject();
  partnerDetailData = new Subject();
  socialSaveProfile = new Subject();
  studentProfileSave = new Subject();
  studentDetailData = new Subject();
  saveProfile = new Subject();
  dynamicStudentDetailData = new ReplaySubject<any>();
  partnerId = new ReplaySubject();
  hamburger = new Subject();
  saveModal = new Subject();
  sidemenu = new Subject();
  content = new Subject();
  closeCollegeDetail = new Subject();
  studentQuestionaryThreeCloseFlag = new Subject();
  studentProfileNavigation = new Subject();
  showStudentProfilePopup = new Subject();
  studentEmailData = new Subject();
  solidGaugeData = new Subject();
  updateProfile = new Subject();
  updateMessageCount = new Subject();
  testScoreClicked = new Subject();
  showTabClicked = new Subject();
  showTabClickedGPA = new Subject();
  showTabClickedSAT = new Subject();
  showTabClickedEFC = new Subject();
  sessionExpired = new Subject();
  parentData = new Subject();
  updatePersonalBest = new Subject();
  heatMapOverviewUpdate = new Subject();
  toggleSideMenu = new Subject();
  coachStudentUpdate = new Subject();
  updateCollegeList = new Subject();
  partnerChange = new Subject();
  parentHeatMapTab = new Subject();
  sameClientNoDetails = new Subject();
  checkPinUnpinCollege = new Subject();
  collapseMenu = new Subject();
  testScoreUpdate = new Subject();
  collegeListPageChange = new Subject();
  closeBrickPopUp = new Subject();
  openPopUpSubject = new Subject();
  closeChatWindowSubject = new Subject();
  minimizeChatWindowsubject = new Subject();
  bulkEmailEditSubject = new Subject();
  reloadStudentCareer = new Subject();

  gridReRender = new Subject();
  updateCoachStudentDetail = new Subject();
  addCollege = new Subject();
  unpinCollege = new Subject();
  pinCollege = new Subject();
  reRenderMyPlan = new Subject();
  callParentProfile = new Subject();
  updateMessageTemplate = new Subject();
  updateStudentDocuments = new Subject();
  reloadAutoNotes = new Subject();
  goBackFlag = new Subject();
  heatMapType = new Subject();
  studentProfileUpdate = new Subject();
  summaryTab = new Subject();
  studentMenu = new Subject();
  coachStudentLoginStatus = new Subject();
  loginDatas = new Subject();
  getProgression = new Subject();
  autoBrick = new Subject();
  myfitData = new Subject();
  loader = new Subject();
  showLoader = new Subject();
  collegesFilter = new Subject();
  avatarUpdate = new Subject();
  saveEmailPhone = new Subject();
  updateListbuilder = new Subject();
  updateSecurityGroups = new Subject();
  duplicateContact = new Subject();
  questionModal = new Subject();
  readMore = new Subject();
  navigateCareer = new Subject();
  careerResultNavReset = new Subject();
  careerAssessmentApiCall = new Subject();
  isMultiCheck = new Subject<boolean>();
  isFirstLogOn = new Subject<boolean>();
}

/*PlanProgressDataService*/
